import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './Navbar.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Our Story', path: '/story' },
  { label: 'Recipes', path: '/recipes' },
  { label: 'Products', path: '/products' },
  { label: 'Blogs', path: '/blogs' },
  { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className={`navbar ${scrolled ? 'scrolled' : ''}`}
      >
        <div className="nav-inner">
          {/* Logo */}
          <Link to="/" className="nav-logo">
            <div className="logo-emblem">
              <svg viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1" opacity="0.4"/>
                <path d="M20 8 C20 8, 28 14, 28 22 C28 30, 20 34, 20 34 C20 34, 12 30, 12 22 C12 14, 20 8, 20 8Z" fill="currentColor" opacity="0.15"/>
                <circle cx="20" cy="20" r="4" fill="currentColor"/>
                <path d="M20 12 L20 8 M20 32 L20 28 M12 20 L8 20 M32 20 L28 20" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
              </svg>
            </div>
            <div className="logo-text">
              <span className="logo-name">Ragini</span>
              <span className="logo-sub">Masale</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <ul className="nav-links">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                >
                  {link.label}
                  <span className="nav-link-underline" />
                </Link>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="nav-actions">
            <Link to="/products" className="nav-cta">
              <span>View Products</span>
              <svg viewBox="0 0 20 20" fill="none" width="14" height="14">
                <path d="M5 10H15M11 6l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>

            {/* Hamburger */}
            <button
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, clipPath: 'inset(0 0 100% 0)' }}
            animate={{ opacity: 1, clipPath: 'inset(0 0 0% 0)' }}
            exit={{ opacity: 0, clipPath: 'inset(0 0 100% 0)' }}
            transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className="mobile-menu-inner">
              <ul>
                {navLinks.map((link, i) => (
                  <motion.li
                    key={link.path}
                    initial={{ opacity: 0, x: -40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 + i * 0.07, duration: 0.5 }}
                  >
                    <Link to={link.path} className="mobile-link">
                      <span className="mobile-link-num">0{i + 1}</span>
                      {link.label}
                    </Link>
                  </motion.li>
                ))}
              </ul>
              <div className="mobile-footer-text">
                <span>Est. 2005</span>
                <span>Pure. Aromatic. Authentic.</span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
